import { createFileRoute } from '@tanstack/react-router'

import { RoomAddView } from '@/modules/rooms'

export const Route = createFileRoute('/_auth/rooms/add')({
  component: RoomAddView
})
